var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { overmind } from '@/overmind';
import { MediaRecorder } from '@/interfaces/media.interfaces';
import { getRecordCategories, getUserProspectingLogs, saveUserProspectingLog, deleteUserProspectingLog, } from '@/clients/applets';
import { NotificationService } from '@/services/NotificationService';
let Record = class Record extends Vue {
    constructor() {
        super(...arguments);
        this.tab = 'new';
        this.categories = [];
        this.selectedCategory = '';
        this.observations = '';
        this.isRecording = false;
        this.audioUrl = '';
        this.audioBlob = null;
        this.mediaRecorder = null;
        this.chunks = [];
        this.recordingTime = 0;
        this.timerInterval = null;
        this.saving = false;
        this.savedRecords = [];
        this.loadingRecords = false;
    }
    get formattedTime() {
        const minutes = Math.floor(this.recordingTime / 60);
        const seconds = this.recordingTime % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds
            .toString()
            .padStart(2, '0')}`;
    }
    onTabChange(newTab) {
        if (newTab === 'saved') {
            this.fetchSavedRecords();
        }
    }
    async created() {
        await this.fetchCategories();
    }
    async fetchCategories() {
        try {
            const userId = overmind.state.users.currentUser && overmind.state.users.currentUser.id;
            const response = await getRecordCategories(userId);
            if (response &&
                response.status === 200 &&
                response.data &&
                response.data.categories) {
                this.categories = response.data.categories;
            }
        }
        catch (error) {
            console.error('Error fetching record categories:', error);
        }
    }
    async fetchSavedRecords() {
        this.loadingRecords = true;
        try {
            const res = await getUserProspectingLogs(this.infosetId, this.companyId);
            if (res && res.status === 200 && res.data) {
                if (res.data.data && Array.isArray(res.data.data)) {
                    this.savedRecords = res.data.data.map((log) => ({
                        ...log.attributes,
                        id: log.id,
                        category: log.attributes.type_log,
                        observation: log.attributes.annotation,
                        file_url: (log.attributes.audios &&
                            log.attributes.audios.data &&
                            log.attributes.audios.data.length > 0 &&
                            (log.attributes.audios.data[0].url ||
                                log.attributes.audios.data[0].file_url)) ||
                            log.attributes.file_url,
                    }));
                }
                else if (res.data.logs && Array.isArray(res.data.logs)) {
                    this.savedRecords = res.data.logs;
                }
                else if (Array.isArray(res.data)) {
                    this.savedRecords = res.data;
                }
                else {
                    this.savedRecords = [];
                }
            }
        }
        catch (error) {
            console.error('Error fetching saved records:', error);
        }
        finally {
            this.loadingRecords = false;
        }
    }
    async toggleRecording() {
        if (this.isRecording) {
            this.stopRecording();
        }
        else {
            await this.startRecording();
        }
    }
    async startRecording() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            this.mediaRecorder = new MediaRecorder(stream);
            this.chunks = [];
            this.mediaRecorder.ondataavailable = e => {
                if (e.data.size > 0) {
                    this.chunks.push(e.data);
                }
            };
            this.mediaRecorder.onstop = () => {
                this.audioBlob = new Blob(this.chunks, { type: 'audio/webm' });
                this.audioUrl = URL.createObjectURL(this.audioBlob);
                stream.getTracks().forEach(track => track.stop());
            };
            this.mediaRecorder.start();
            this.isRecording = true;
            this.audioUrl = '';
            this.audioBlob = null;
            this.recordingTime = 0;
            this.timerInterval = window.setInterval(() => {
                this.recordingTime++;
            }, 1000);
        }
        catch (error) {
            console.error('Error starting recording:', error);
            NotificationService.error('Erro', 'Não foi possível acessar o microfone.');
        }
    }
    stopRecording() {
        if (this.mediaRecorder && this.isRecording) {
            this.mediaRecorder.stop();
            this.isRecording = false;
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timerInterval = null;
            }
        }
    }
    onCancel() {
        this.$emit('close');
        this.resetForm();
    }
    resetForm() {
        this.selectedCategory = '';
        this.observations = '';
        this.audioUrl = '';
        this.audioBlob = null;
        this.recordingTime = 0;
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
    }
    async onSave() {
        if (!this.audioBlob)
            return;
        this.saving = true;
        try {
            const formData = new FormData();
            formData.append('type_log', this.selectedCategory);
            formData.append('annotation', this.observations);
            formData.append('file', this.audioBlob, 'recording.webm');
            const res = await saveUserProspectingLog(this.infosetId, this.companyId, formData);
            const success = res && (res.status === 200 || res.status === 201);
            if (success) {
                NotificationService.success('Sucesso', 'Registro salvo com sucesso!');
                this.tab = 'saved';
                this.resetForm();
            }
            else {
                NotificationService.error('Erro', 'Erro ao salvar registro.');
            }
        }
        catch (error) {
            console.error('Error saving record:', error);
            NotificationService.error('Erro', 'Ocorreu um erro inesperado.');
        }
        finally {
            this.saving = false;
        }
    }
    downloadRecord(record) {
        const url = record.file_url || record.url;
        if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `gravacao-${record.id || record._id}.webm`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    confirmDelete(logId) {
        this.$q
            .dialog({
            title: 'Confirmar exclusão',
            message: 'Tem certeza que deseja excluir este registro?',
            cancel: true,
            persistent: true,
        })
            .onOk(() => {
            this.deleteRecord(logId);
        });
    }
    async deleteRecord(logId) {
        try {
            const res = await deleteUserProspectingLog(this.infosetId, this.companyId, logId);
            const success = res && (res.status === 200 || res.status === 204);
            if (success) {
                NotificationService.success('Sucesso', 'Registro excluído com sucesso!');
                await this.fetchSavedRecords();
            }
            else {
                NotificationService.error('Erro', 'Erro ao excluir registro.');
            }
        }
        catch (error) {
            console.error('Error deleting record:', error);
        }
    }
    formatDate(date) {
        if (!date)
            return '';
        return new Date(date).toLocaleString('pt-BR');
    }
};
__decorate([
    Prop({ default: '' })
], Record.prototype, "infosetId", void 0);
__decorate([
    Prop({ default: '' })
], Record.prototype, "companyId", void 0);
__decorate([
    Prop({ default: () => ({}) })
], Record.prototype, "company", void 0);
__decorate([
    Watch('tab')
], Record.prototype, "onTabChange", null);
Record = __decorate([
    Component({})
], Record);
export default Record;
